(() => {
  const CARD_SELECTOR = '[data-card-with-secondary-actions]';
  const SECONDARY_SELECTOR = '[data-secondary-action-button]';
  const TRIGGER_ATTR = 'data-secondary-action-trigger';
  const HINT_ID = 'CardSecondaryActionHint';
  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function isInsideDialog(node) {
    return Boolean(node.closest('quick-add-modal, .modal, [role="dialog"]'));
  }

  function isUnavailableForPrimaryTrigger(node) {
    return (
      node.getAttribute('tabindex') === '-1' ||
      node.getAttribute('aria-hidden') === 'true' ||
      node.hidden
    );
  }

  function getSecondaryAction(card) {
    return card.querySelector(SECONDARY_SELECTOR);
  }

  function getPrimaryTrigger(card) {
    const candidates = card.querySelectorAll(FOCUSABLE_SELECTOR);
    for (const candidate of candidates) {
      if (candidate.matches(SECONDARY_SELECTOR)) continue;
      if (isInsideDialog(candidate)) continue;
      if (isUnavailableForPrimaryTrigger(candidate)) continue;
      return candidate;
    }
    return null;
  }

  function ensureHintConnection(trigger) {
    const describedBy = (trigger.getAttribute('aria-describedby') || '').trim();
    if (!describedBy) {
      trigger.setAttribute('aria-describedby', HINT_ID);
      return;
    }
    if (!describedBy.split(/\s+/).includes(HINT_ID)) {
      trigger.setAttribute('aria-describedby', `${describedBy} ${HINT_ID}`);
    }
  }

  function initCard(card) {
    if (card.dataset.secondaryActionReady === 'true') return;

    const secondary = getSecondaryAction(card);
    if (!secondary) return;

    // Keep card tab flow concise; ArrowDown moves into the secondary action.
    secondary.setAttribute('tabindex', '-1');

    const trigger = getPrimaryTrigger(card);
    if (trigger) {
      trigger.setAttribute(TRIGGER_ATTR, 'true');
      ensureHintConnection(trigger);
    }

    card.dataset.secondaryActionReady = 'true';
  }

  function initAllCards() {
    document.querySelectorAll(CARD_SELECTOR).forEach(initCard);
  }

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest(`[${TRIGGER_ATTR}="true"]`);
    if (trigger && event.key === 'ArrowDown') {
      const card = trigger.closest(CARD_SELECTOR);
      const secondary = card && getSecondaryAction(card);
      if (secondary) {
        event.preventDefault();
        secondary.focus();
      }
      return;
    }

    const secondary = event.target.closest(SECONDARY_SELECTOR);
    if (secondary && (event.key === 'Escape' || event.key === 'ArrowUp')) {
      const card = secondary.closest(CARD_SELECTOR);
      const triggerForCard = card && getPrimaryTrigger(card);
      if (triggerForCard) {
        event.preventDefault();
        triggerForCard.focus();
      }
    }
  });

  document.addEventListener('DOMContentLoaded', initAllCards);
})();
